import React, { useEffect, useState } from 'react'
import { MissionType } from '../../../../domain/enum/mission-type.enum'

import { makePostMissionAnswer, makePutMissionAnswer } from '../../../../main/usecases/mission-answer/post-mission-answer-factory'
import { t } from '../../../adapters/translate/translate'
import { useGame, useGameWrapper } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { addAllowFullScreen, replaceInstructionsTags } from '../../../utils/mission_helpers'
import { getTeam } from '../../../utils/team_helpers'
import { Container, Image, Instructions } from '../styles'
import {
  Form,
  FieldGroup,
  Label,
  Textarea,
  AiAlert
} from './styles'
import { replaceHtmlEntity } from '../../../utils/text_replace'

const OpenAnswerMission = () => {
  const [instructions, setInstructions] = useState<string|null>('')
  const [answer, setAnswer] = useState('')
  const [uuid, setUuid] = useState<string>('')
  const [status, setStatus] = useState<string>('')
  const [color, setColor] = useState<any>('#fff')
  const { game } = useGame()
  const team = getTeam()
  const { timeout, attempts, currentMission, submitCallback, doSubmit, submitButtonIsEnabled, handleToggleStatusSubmitButton, setTimePaused } = useGameWrapper()

  async function initAnswer () {
    try {
      if (team.id && currentMission?.type !== MissionType.PICTURE) {
        const res = await makePostMissionAnswer().post({
          mission: currentMission?.uuid,
          team: team.id
        })
        setUuid(res['@id'] || '')
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
    }
  }

  async function sendAnswer () {
    try {
      if (team.id) {
        const missionAttempts = currentMission?.options?.attempts
        let missionAnswer: any = { description: answer }

        if (missionAttempts && missionAttempts > 1) {
          missionAnswer = { ...missionAnswer, attempts: (missionAttempts - attempts) + 1 }
        }

        const res = await makePutMissionAnswer(uuid).update({
          answer: [missionAnswer],
          status: timeout ? 'timeout' : status
        })

        setAnswer('')
        return res
      }
    } catch (error) {
      console.error('OpenAnswerMission.sendAnswer', error)
      setAnswer('')
    }
  }

  function handleEnableButton () {
    if (answer.trim().length === 0) {
      handleToggleStatusSubmitButton(false)
    } else {
      handleToggleStatusSubmitButton(true)
    }
  }

  useEffect(() => {
    handleEnableButton()
  }, [answer])

  useEffect(() => {
    if (doSubmit && submitButtonIsEnabled) {
      submitCallback(sendAnswer)
    }
  }, [doSubmit, submitButtonIsEnabled])

  useEffect(() => {
    initAnswer()
  }, [JSON.stringify(currentMission?.uuid)])

  useEffect(() => {
    setAnswer('')
    setStatus('responded')
    if (!currentMission) return
    const formattedInstructions = replaceInstructionsTags({ mission: currentMission, points: currentMission.pointsIfCorrect })
    setInstructions(addAllowFullScreen(formattedInstructions))
  }, [currentMission])

  useEffect(() => {
    if (timeout) {
      submitCallback(sendAnswer)
    }
  }, [timeout])

  useEffect(() => {
    setTimePaused(false)
    if (game) { setColor(game?.textColor || '#fff') }
  }, [game])

  useEffect(() => {
    const div = document.getElementById('instructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [instructions])

  return (
    <Container>
      { currentMission?.icon && <Image src={getAssetUrl('icon', String(currentMission?.icon))} /> }
      {!!instructions && <Instructions id="instructions" dangerouslySetInnerHTML={
        { __html: instructions }
      } />}

      <Form>
        <FieldGroup>
          <Label style={{ color }} >{t('Register below')}</Label>
          <Textarea
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setAnswer(e.target.value)}
            value={answer}
            placeholder={`${t('Enter here')}...`}
          />
        </FieldGroup>
        {currentMission?.pointsIfCorrect && (<AiAlert strong={true}>{t('Points will be awarded after content verification.')}</AiAlert>)}
      </Form>
    </Container>
  )
}

export default OpenAnswerMission
